import { useEffect, useState } from "react";
import { getCountryConfig, subscribeCountryConfig } from "./countryConfig";

/**
 * useCountryConfig — small reactive hook that re-renders when the
 * `/api/country-config` fetch resolves (or any future hot-swap event).
 * Returns the current snapshot synchronously; components can read it
 * immediately and trust they'll be re-rendered when the real config
 * lands a tick later.
 */
export function useCountryConfig() {
  const [cfg, setCfg] = useState(() => getCountryConfig());
  useEffect(() => {
    // Subscribe synchronously and rely on the publisher to push the
    // current value via the setter. Avoids the set-state-in-effect
    // lint rule while still resyncing after late-arriving fetches.
    return subscribeCountryConfig(setCfg);
  }, []);
  return cfg;
}

export default useCountryConfig;
